// First-party, random client identifier. Not a MAC address or an unspoofable
// hardware fingerprint. Keep it stable across refreshes and both LULS worlds.
const key = 'lulseo-device-hdid-v1';
let memoryId: string | undefined;

function valid(value: string | null): value is string {
  return value !== null && /^[1-9][0-9]{0,9}$/.test(value) && Number(value) <= 2147483647;
}

function generate(): string {
  const values = new Uint32Array(1);
  try {
    globalThis.crypto.getRandomValues(values);
    return String((values[0] % 2147483647) + 1);
  } catch {
    return String(Math.floor(Math.random() * 2147483647) + 1);
  }
}

export function getDeviceId(): string {
  try {
    const stored = globalThis.localStorage.getItem(key);
    if (valid(stored)) return (memoryId = stored);
    const id = memoryId ?? (memoryId = generate());
    globalThis.localStorage.setItem(key, id);
    return id;
  } catch {
    return memoryId ?? (memoryId = generate());
  }
}
